(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["academy-language"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('academy-language')) {
  customElements.define('academy-language', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-language]');
        if (!button || !this.contains(button)) return;
        this.querySelectorAll('button[data-language]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-language-panel]').forEach((panel) => { panel.hidden = panel.dataset.languagePanel !== button.dataset.language; });
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
